<script>
export default {
  props: {
    module: Object,
  },
  methods: {
    remove(item) {
      item.remove();
    },
    itemClass(item) {
      return {
        green: item.type === 'success',
        red: item.type === 'error',
        yellow: item.type === 'warning',
        blue: item.type === 'info',
      };
    },
    itemColor(item) {
      switch (item.type) {
        case 'success':
          return 'green darken-4';
        case 'error':
          return 'red darken-4';
        case 'warning':
          return 'yellow darken-4';
        default:
        case 'info':
          return 'blue darken-4';
      }
    },
    itemIcon(item) {
      switch (item.type) {
        case 'success':
          return 'mdi-checkbox-marked-circle-outline';
        case 'error':
          return 'mdi-close-circle-outline';
        case 'warning':
          return 'mdi-alert-circle-outline';
        default:
        case 'info':
          return 'mdi-alert-circle-outline';
      }
    },
  },
};
</script>
<template>
  <div v-if="module.items.length" class="mag-template-notify">
    <v-sheet
      v-for="(item, idx) in module.items"
      :key="item.ID"
      :elevation="6"
      class="mag-template-notify__item lighten-5"
      :class="itemClass(item)"
      :style="{top: `${idx * 12}px`}"
    >
      <v-list-item
      >
        <v-list-item-action>
          <v-icon :color="itemColor(item)" v-text="itemIcon(item)"></v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title v-if="item.title">{{ item.title }}</v-list-item-title>
          <v-list-item-subtitle v-html="item.message"/>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            title="Скрыть"
            icon
            @click="item.remove()"
          >
            <v-icon v-text="'mdi-close-circle-outline'"></v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-sheet>
  </div>
</template>
<style lang="scss">
  .mag-template-notify {
    z-index: 3000;
    position: absolute;
    right: 0;
    top: 72px;

    &__item {
      width: 420px;
      position: absolute;
      right: 8px;
      top: 8px;
      border-radius: 4px;
    }
  }
</style>
